/* eslint-disable eslint-comments/disable-enable-pair, react/jsx-no-literals, react/jsx-one-expression-per-line */
import React from 'react';

import Tile from 'src/components/Tile/Tile';
import TileActionsToggle from 'src/components/Tile/TileActionsToggle';
import SeeAllTile from 'src/components/SeeAllTile';
import EmptyListing from 'src/components/EmptyListing';
import { useDailyOffersContainer, sendAnalyticsEvent } from './utils';


const DailyOffersContainer = () => {
  const { offers, links, toggleFavouriteOffer } = useDailyOffersContainer();

  if (offers.length === 0) {
    return (
      <EmptyListing
        copy=""
        header="Zobacz wszystkie oferty"
        link={ links.LINK_JOB_OFFERS }
      />
    );
  }

  return (
    <React.Fragment>
      {
        offers.map((offer, index) => (
          <Tile
            key={ offer.offerId }
            callback={ event => sendAnalyticsEvent(event, { ...offer, position: index }) }
            offer={ offer }
          >
            <TileActionsToggle
              isFavourite={ offer.isFavourite }
              toggleFavourite={ () => toggleFavouriteOffer(offer.offerId, offer.isFavourite) }
            />
          </Tile>
        ))
      }

      <SeeAllTile
        link={ links.LINK_JOB_OFFERS }
        title="Zobacz wszystkie oferty"
      >
        {' '}
Zobacz wszystkie
        <br />
        {' '}
oferty
      </SeeAllTile>
    </React.Fragment>
  );
};

export default DailyOffersContainer;
